import { render } from "./FollowerDetailPanel.vue?vue&type=template&id=c311e3be&scoped=true"
import script from "./FollowerDetailPanel.vue?vue&type=script&lang=js"
export * from "./FollowerDetailPanel.vue?vue&type=script&lang=js"

import "./FollowerDetailPanel.vue?vue&type=style&index=0&id=c311e3be&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c311e3be"]])

export default __exports__